export const DESCRIPTION_SCROLLED = '|A|AvatarActions.DESCRIPTION_SCROLLED'
export const MUTE = 'AvatarActions.MUTED'
export const UNMUTE = 'AvatarActions.UNMUTED'
export const SHOW = 'AvatarActions.SHOW'
export const HIDE = 'AvatarActions.HIDE'

export const descriptionScrolled = () => ({
    type: DESCRIPTION_SCROLLED,
})

export const mute = () => ({
    type: MUTE,
})

export const unmute = () => ({
    type: UNMUTE,
})

export const showAvatar = () => ({
    type: SHOW,
})

export const hideAvatar = () => ({
    type: HIDE,
})
